export const fouinesduplateau = {
  logo_image_url: 'fouinesduplateau.png',
  logo_height: 60,
  tokens: [
    'fouinesduplateau/pastille-1.png',
    'fouinesduplateau/pastille-2.png',
    'fouinesduplateau/pastille-3.png',
    'fouinesduplateau/pastille-4.png',
    'fouinesduplateau/pastille-5.png',
    'fouinesduplateau/pastille-6.png',
  ],
  token_width: 110,
  number_color: '#fdf05e',
  number_hidden_tokenIds: [0, 10],
  number_top: 15,

  body_background_color: '#ffc400',

  button_color: '#e4002a',
  button_radius: 25,
  button_half_border_color: '#9e2254',

  text_font: `'Arial', sans-serif`,
  text_color: 'black',
  title_font: `'Arial', sans-serif`,
}

export const fouinesduplateau_secondary = {
  ...fouinesduplateau,
  number_hidden: true,
}
